// El FORMATO de los identificadores que viajan por la aplicacion. Un solo sitio.
//
// El patron del UUID vivia escrito dentro de la expresion de `rutaProfunda.js`, y el
// 28-ago-2026 hizo falta el mismo patron en el cliente de la API para no componer la
// URL de una peticion con un identificador que no lo es (T-45, jssecurity:S8476).
// Copiarlo habria dejado dos verdades sobre el mismo dato: el dia que una acepte
// mayusculas y la otra no, el enlace del correo abre un caso que la API rechaza.
//
// Se expone el PATRON como texto —sin anclas— porque `rutaProfunda` lo necesita
// incrustado dentro de una expresion mayor (`^/casos/<uuid>/?$`), y aparte la
// comprobacion ya anclada, que es lo que usa todo el mundo.
//
// El backend declara estos identificadores como `UUID` en la firma de sus rutas
// (`CasoId = Annotated[UUID, Path(...)]`): esto es la MISMA regla, comprobada antes
// de salir a la red.

/** El cuerpo de un UUID, para incrustar en expresiones mayores. Sin anclas. */
export const PATRON_UUID = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';

// Anclada a los dos extremos: sin `^` y `$` valdria cualquier texto que CONTENGA un
// uuid, que es justo lo que un identificador manipulado trae ("../admin/<uuid>").
const ES_UUID = new RegExp(`^${PATRON_UUID}$`, 'i');

// `unknown` y no `string`: la gracia de esta funcion es que se le pasa lo que llega
// de fuera -de la URL, de una respuesta, de `localStorage`- sin saber que es. Y el
// tipo de retorno es una GUARDA (`valor is string`): despues de un `if (esUuid(x))`
// TypeScript ya sabe que `x` es un string, sin que nadie tenga que afirmarlo a mano.
/** true si `valor` es un UUID (mayusculas o minusculas), false para todo lo demas. */
export function esUuid(valor: unknown): valor is string {
  return typeof valor === 'string' && ES_UUID.test(valor);
}
